module.exports = __webpack_public_path__ + "img/cavalier-challenge-1-2x_300aee6c57ddf35afbc398ddc56af16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-1-2x.jpg
// module id = 260
// module chunks = 0